var _rect, _rect2, _path, _path2, _circle, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.57251,
    y: 7.71429,
    width: 21.8571,
    height: 14.1429,
    rx: 2.57143,
    fill: "#37383A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5011,
    y: 9.64288,
    width: 7.71429,
    height: 10.2857,
    rx: 0.642857,
    fill: "#ADADAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14392 18.6429C5.14392 17.6786 5.18936 15.4286 8.35821 15.4286C11.5271 15.4286 11.5725 17.6786 11.5725 18.6429C9.96535 18.6429 9.64392 18.6429 8.35821 18.6429C7.07249 18.6429 6.42964 18.6429 5.14392 18.6429Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5011 4.5C12.081 4.5 10.9297 5.65127 10.9297 7.07143H16.0725C16.0725 5.65127 14.9213 4.5 13.5011 4.5Z",
    fill: "#37383A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.35826,
    cy: 12.8572,
    r: 1.92857,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1439,
    y: 10.9286,
    width: 8.35714,
    height: 1.28571,
    rx: 0.642857,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1439,
    y: 14.1429,
    width: 8.35714,
    height: 1.28571,
    rx: 0.642857,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1439,
    y: 17.3571,
    width: 8.35714,
    height: 1.28571,
    rx: 0.642857,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/Age.052d932c22c21d566cf17903b3b112d6.svg";
export { ForwardRef as ReactComponent };